import icon1 from "assets/images/pg-icon1.png";
import icon2 from "assets/images/pg-icon2.png";
import icon3 from "assets/images/pg-icon3.png";
import icon4 from "assets/images/pg-icon4-secure-payment.png";
import icon6 from "assets/images/icon-online-shopping.png";
import icon5 from "assets/images/pg-icon5.png";

export const gatewayFeatures = [
  {
    text: (
      <span>
        Accept online payments without the hassle. <b>YOOZ</b> provides online payment
        processing with built-in security and compliance, reducing operational
        risk.
      </span>
    ),
    img: icon4,
  },
  { text: "Customers complete payments faster with fewer steps.", img: icon6 },
  { text: "No need for IT or expensive e-commerce sites. Our mobile-friendly design performs consistently across devices.", img: icon3 },
  {
    text: "Supports REST API Integration.",
    img: icon1,
  },
  {
    text: "Applies record of customer payments to your accounting system in real time.",
    img: icon2,
  },
];
